import { CurrentUser } from "@/models/auth/current.user";
import { UserDto, LanguageDto, ActivityAreaDto } from "@/server/app.dtos";

// Mutations
export const MUTATE_CORE = "shared/MUTATE_CORE";
export const MUTATE_LANGUAGES = "shared/MUTATE_LANGUAGES";
export const MUTATE_ACTIVITY_AREAS = "shared/MUTATE_ACTIVITY_AREAS";
export const MUTATE_IDENTITY = "shared/MUTATE_IDENTITY";
export const MUTATE_PROFILE = "shared/MUTATE_PROFILE";
export const MUTATE_CLEAR = "shared/MUTATE_CLEAR";

// Actions
export const LOGIN = "shared/USER_LOGIN";
export const PROFILE_UPDATE = "shared/PROFILE_UPDATE";
export const IDENTITY_UPDATE = "shared/IDENTITY_UPDATE";
export const LOGOUT = "shared/USER_LOGOUT";

export const GLOBAL_USER_TOKEN = "token";

export interface RootState {
  identity: CurrentUser | null;
  profile: UserDto | null;
  languages: LanguageDto[];
  activityAreas: ActivityAreaDto[];
  currentLanguage: LanguageDto;
}
